const MDAllyPayors = (function($) {
    
    const controller = new ScrollMagic.Controller();
    const EO = Elastic.easeOut.config;
 	
 	let	isTesting = false;
 	let nodeCanvas;
 	let animationCanvas;
 	let animationCanvasMobile;
 	let currentSection = 0;

    const onInit = function() {

    	animationCanvas = $( 'section.payors-animation .animation-container .payors-animation');
    	animationCanvasMobile = $( 'section.payors-animation .animation-container .payors-animation-mobile');

    	if( animationCanvasMobile.data('isReady') && animationCanvas.data('isReady') ) {
    		initAnimationCanvas();
    	} else {
    		animationCanvas.data('onReady' , initAnimationCanvas );
    		animationCanvasMobile.data('onReady' , initAnimationCanvas );
    	}
		
    }

    function initAnimationCanvas(m) {
 		if( !animationCanvasMobile.data('isReady') || !animationCanvas.data('isReady') ) return;
    	
    	animationCanvas.data('exportRoot').onInit( false );
    	animationCanvasMobile.data('exportRoot').onInit( false );
    	
    	initPageScrollElements();
		jQuery('body').css('opacity', 1);
	}

	function initPageScrollElements() {
			
		const containerScene = new ScrollMagic.Scene({
		     triggerElement: 'section.payors-animation',
		     reverse:false,
		     triggerHook: 0.8
		})
		.setTween( gsap.fromTo( animationCanvas.data('exportRoot').tl , 8 , {progress:0} , {progress:1 } ) )
		//.addIndicators()
		.addTo(controller);

		const container2Scene = new ScrollMagic.Scene({
		     triggerElement: 'section.payors-animation',
		     reverse:false,
		     triggerHook: 0.8
		})
		.setTween( gsap.fromTo( animationCanvasMobile.data('exportRoot').tl , 8 , {progress:0} , {progress:1 } ) )
		//.addIndicators()
		.addTo(controller);


		const charTL = gsap.timeline();
			charTL.add( "start" , "+=0" );
			charTL.from( $(".stat-image path[data-name='stat01']") , 1.5 , {y:"+=300" , ease:EO(0.8,1)} , "start+=0" );
			charTL.from( $(".stat-image path[data-name='stat02']") , 1.5 , {y:"+=300" , ease:EO(0.8,1)} , "start+=0.1" );
			charTL.from( $(".stat-image path[data-name='stat03']") , 1.5 , {y:"+=300" , ease:EO(0.8,1)} , "start+=0.2" );

		const chartElem = {
			name: 'chartElem',
    		el: 'section.stats-block',
    		trigger: {triggerElement: 'section.stats-block' , triggerHook: 0.4  },
    		gsap: charTL,
    		pin : null,
    		scene: null,
    		inited : false,
    		desktopOnly: false
    	}
    	chartElem.scene = MDAllyAnimations.add( chartElem );

    	MDAllyAnimations.update();
	}

    return {
    	init: onInit,
    }; 

})(jQuery);
